import React from 'react';
import { List, Grid } from 'antd-mobile';
import { Row, Col } from 'react-onsenui';
import { formatCompetitionName } from '../../../../../../helpers';
import './Detail.css';
import PropTypes from 'prop-types';
import { LOGO_TEAM_URL } from '../../../../../../config.env';

const Detail = props => {
    return (
        <div style={{paddingBottom: '15px'}} className='ls_match_detail'>
            <List.Item wrap>
                <Row>
                    <Col>
                        <div className='center-align common' style={{marginTop: '15px', marginBottom: '15px'}}>
                            {formatCompetitionName(props.competition, props.journee, props.cpType)}
                        </div>
                    </Col>
                </Row>
                <Grid 
                    data={[
                        {icon: `${LOGO_TEAM_URL}/${props.homeTeamClCod}.jpg`, text: props.homeTeam},
                        {icon: '', text: 'score'},
                        {icon: `${LOGO_TEAM_URL}/${props.awayTeamClCod}.jpg`, text: props.awayTeam}
                    ]}
                    columnNum={3}
                    hasLine={false}
                    square={false}
                    renderItem={el => el.text === 'score' ? (
                        <div className='box-score center-align' style={{minWidth: '33px', paddingTop: 15, margin: 'auto', width: '50%'}}>
                            {score(props)}
                        </div>
                    ) : (
                        <div className="am-grid-item-inner-content column-num-3">
                            <img className="am-grid-icon" src={el.icon} alt={el.text} style={{width: 45, height: 45}} />
                            <div className="am-grid-text" style={styles.common}>{el.text}</div>
                        </div>
                    )}
                />
            </List.Item>
        </div>
    )
}

const styles = {
    common: {
        color: '#004586',
        fontSize: 14,
        fontFamily: 'fff-equipe',
        fontWeight: 700
    }
}

const score = props => props.page === 'upcomingMatch' ? <span style={{color: '#004586', fontWeight: '700', fontFamily: 'fff-equipe'}}>VS</span> : (<div className="score" style={{backgroundColor: '#004586'}}>{`${props.homeTeamGoals ? props.homeTeamGoals : '' }:${props.awayTeamGoals ? props.awayTeamGoals : '' }`}</div>)

Detail.propTypes = {
    competition: PropTypes.string.isRequired,
    journee: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            pj_lib_tour: PropTypes.string,
            pj_no: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        })
    ]).isRequired,
    cpType: PropTypes.string,
    homeTeamClCod: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    homeTeam: PropTypes.string.isRequired,
    homeTeamGoals: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    awayTeamGoals: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    awayTeamClCod: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    awayTeam: PropTypes.string.isRequired,
}

export default Detail;